import { render, staticRenderFns } from "./notification-IssueExpired.vue?vue&type=template&id=67adce6e&scoped=true"
import script from "./notification-IssueExpired.vue?vue&type=script&lang=js"
export * from "./notification-IssueExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67adce6e",
  null
  
)

export default component.exports